import {IManagableObject} from "../../IManagableObject";
import {GeozoneViewModel} from "../../Geozone/Model/GeozoneViewModel";
import {RouteViewModel} from "../../Routes/Model/RouteViewModel";
import {ObjectModel} from "../../../../models/ObjectModel";
declare var moment: any;

export class TaskViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Description: string = "";
  TaskCompletedDate: number = +moment().format('x');
  Repeat: number = 0;
  TrackerId: number = 0;
  Tracker: ObjectModel = new ObjectModel();
  Latitude: number = 0;
  Longitude: number = 0;
  ZoneId: number = 0;
  Zone: GeozoneViewModel = new GeozoneViewModel();
  RouteId: number = 0;
  Route: RouteViewModel = new RouteViewModel();
  Radius: number = 100;

  intTarget: string = 'Point';

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Description = data["description"];
      this.TaskCompletedDate = data["taskCompletedDate"];
      this.Repeat = data["repeat"];
      this.Radius = data["radius"];
      this.Latitude = data["latitude"];
      this.Longitude = data["longitude"];
      if (data["zone"])
        this.Zone = GeozoneViewModel.fromJS(data["zone"]);
      this.ZoneId = data["zoneId"];
      this.Tracker = ObjectModel.fromJS(data["tracker"]);
      this.TrackerId = data["trackerId"];
      this.Route = RouteViewModel.fromJS(data["route"]);
      this.RouteId = data["routeId"];

      this.intTarget = this.RouteId ? "Route" : (this.ZoneId ? "Geozone" : "Point");
    }
  }

  static fromJS(data: any): TaskViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TaskViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
